import { generateUUID } from "../../../utils/uuid";
import { ReviewComment } from "../context";

export const dpaDemoComments: ReviewComment[] = [
  {
    _id: generateUUID(),
    comment:
      'Insert "Key regulations include the California Consumer Privacy Act of 2018".',
    persona: "legal",
    x: 0,
    y: 0,
    page_num: 1,
    timestamp: 0,
    required: false,
  },
  {
    _id: generateUUID(),
    comment: 'Insert "Remove "with".',
    persona: "legal",
    x: 0,
    y: 0,
    page_num: 1,
    timestamp: 0,
    required: false,
  },
  {
    _id: generateUUID(),
    comment: 'Replace "and repealing" with "considering the repeal of".',
    persona: "legal",
    x: 0,
    y: 0,
    page_num: 1,
    timestamp: 0,
    required: false,
  },
  {
    _id: generateUUID(),
    comment:
      'Low risk: Consider specifying what constitutes "documented instructions" to avoid ambiguity. For example, should these instructions always be in writing, or could they include verbal agreements recorded later?',
    persona: "legal",
    x: 0,
    y: 0,
    page_num: 1,
    timestamp: 0,
    required: false,
  },
  {
    _id: generateUUID(),
    comment:
      "Low risk: This clause prohibiting disclosure to Subprocessors without Company authorization might benefit from defining the process for obtaining authorization, especially in urgent situations.",
    persona: "legal",
    x: 0,
    y: 0,
    page_num: 1,
    timestamp: 0,
    required: false,
  },
  {
    _id: generateUUID(),
    comment:
      "Medium risk: Consider specifying a maximum time frame (e.g. 72 hours) to align with GDPR requirements.",
    persona: "legal",
    x: 0,
    y: 0,
    page_num: 1,
    timestamp: 0,
    required: false,
  },
  {
    _id: generateUUID(),
    comment:
      "Medium risk: The requirement to delete data within 10 business days after cessation could conflict with local legal obligations to retain data. It may be prudent to include a clause allowing exceptions where retention is legally required.",
    persona: "legal",
    x: 0,
    y: 0,
    page_num: 1,
    timestamp: 0,
    required: false,
  },
];
